import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Textarea,
  useDisclosure,
} from '@elkaso-app/web-design';
import { useDeclineCreditUtilizationApi, useGetCreditUtilizationApi } from 'apis/bnpl';
import React from 'react';
import { useForm } from 'react-hook-form';

interface DeclineUtilizationModalProps {
  trigger: JSX.Element;
  utilizationId: number;
}

interface FormInputs {
  notes: string;
}

export const DeclineUtilizationModal = ({ trigger, utilizationId }: DeclineUtilizationModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate, isLoading } = useDeclineCreditUtilizationApi();
  const { refetch } = useGetCreditUtilizationApi(utilizationId, { enabled: false });

  const { register, handleSubmit, reset } = useForm<FormInputs>({
    defaultValues: { notes: '' },
  });

  const onCloseModal = () => {
    reset({ notes: '' });
    onClose();
  };

  const onSubmit = (data: FormInputs) => {
    mutate(
      { utilizationId, body: { notes: data.notes || undefined } },
      {
        onSuccess: () => {
          refetch();
          onCloseModal();
        },
      }
    );
  };

  return (
    <>
      {React.cloneElement(trigger, { onClick: onOpen })}

      <Modal isOpen={isOpen} onClose={onCloseModal} closeOnOverlayClick={false} size='md'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Decline Utilization</ModalHeader>
          <ModalBody>
            <Stack as='form' id='declineUtilizationForm' spacing='lg' onSubmit={handleSubmit(onSubmit)} noValidate>
              <FormControl>
                <FormLabel>Notes (optional)</FormLabel>
                <Textarea {...register('notes')} placeholder="e.g., Invoice amount doesn't match supplier records" />
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onCloseModal}>
                Cancel
              </Button>
              <Button
                variant='solid'
                colorScheme='red'
                type='submit'
                form='declineUtilizationForm'
                isLoading={isLoading}>
                Decline
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
